import ApplyTemplateCommand from "./ApplyTemplateCommand";
import ApplyTemplateEditing from "./ApplyTemplateEditing";
import ApplyTemplateUI from "./ApplyTemplateUI";

import "./applyTemplate.css";

import { Plugin } from "@ckeditor/ckeditor5-core";

export default class ApplyTemplate extends Plugin {
  init() {
    const editor = this.editor;
  }

  static get pluginName() {
    return "ApplyTemplate";
  }

  static get requires() {
    return [ApplyTemplateCommand, ApplyTemplateEditing, ApplyTemplateUI];
  }
}
